import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
import Portal from "@mui/material/Portal";
import { useTranslation } from "react-i18next";

const CustomTooltip = ({
  title,
  desc,
  open,
  imgSrc,
  onClose,
  isMobile,
  isTablet,
  pos,
}) => {
  if (!open) return null;
  const { t } = useTranslation();

  return (
    <Portal>
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: pos?.top ?? 0,
            left: pos?.left ?? 0,
            transform: isMobile
              ? "translate(-50%, 20px)"
              : "translate(-50%, -100%)",
            width: isMobile ? 260 : 280,
            bgcolor: "#f1f5f9",
            zIndex: 999999,
            borderRadius: 2,
            boxShadow: "0px 6px 20px rgba(0,0,0,0.25)",
            p: 2,
            border: "1px solid #E5E7EB",
            pointerEvents: "auto",
          }}
        >
          {imgSrc && (
            <Box
              component="img"
              src={imgSrc}
              alt={title}
              sx={{
                width: 140,
                objectFit: "contain",
                mb: 2,
                mx: "auto",
                display: "block",
              }}
            />
          )}

          <Typography
            variant="subtitle2"
            fontWeight={700}
            mb={0.5}
            textAlign="left"
          >
            {title}
          </Typography>

          <Typography
            variant="body2"
            textAlign="left"
            sx={{ fontSize: "13px", color: "#555" }}
          >
            {desc}
          </Typography>

          {(isMobile || isTablet) && (
            <Typography
              onClick={onClose}
              variant="caption"
              sx={{
                display: "block",
                mt: 1,
                fontWeight: 600,
                textAlign: "center",
                cursor: "pointer",
                textTransform: "uppercase",
              }}
            >
              {t("speed.close")}
            </Typography>
          )}
        </Box>
      </Fade>
    </Portal>
  );
};

CustomTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  imgSrc: PropTypes.string,
  onClose: PropTypes.func,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  pos: PropTypes.object,
};

export default CustomTooltip;
